module.exports = {"data":{"site":{"siteMetadata":{"title":"jackyzhen.com","subtitle":"A Software Developer living in Auckland, NZ","menu":[{"label":"Ramblings","path":"/"},{"label":"About","path":"/about/"},{"label":"Resume","path":"/resume.pdf"}],"author":{"name":"Jacky Zhen","email":"me@jackyzhen.com","github":"jackyzhen","linkedin":"jacky-shunjie-zhen-5b735042","rss":"https://jackyzhen.com/rss.xml"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/404-html.json
// module id = 377
// module chunks = 178698757827068